(function () {
    'use strict';

    angular.module('swif.interventions')
    .factory('goNetEndpointApi', goNetEndpointApi);

    function goNetEndpointApi($http, $window, swif) {
        function getGoNetToken() {
            swif.data.callKw('canadian_municipalities', 'get_login').then(function (result) {
                let data = result
                return $http.post('https://carto.goazimut.com/auth/token', data).then(function (resp) {
                    $window.localStorage.setItem('token', resp.data.access_token);
                    $window.localStorage.setItem('expires_in', resp.data.expires_in);
                    $window.localStorage.setItem('refresh_token', resp.data.refresh_token);
                })
            })
        }

        function getGoNetLayerId(token, cityMapName){
            $http.defaults.headers.common.Authorization = 'Bearer ' + token;
            return $http.get('https://carto.goazimut.com/' + cityMapName + '/arcgis/?f=json')
        }

        function getGoNetSearch(token, input,searchBy, codemuni){
            let data= {
                "input": input, "s": searchBy, "codemuni": codemuni
            }
            $http.defaults.headers.common.Authorization = 'Bearer ' + token;

            return $http.post('https://carto.goazimut.com/search/', data)
        }

        function getGoNetAutoComplete(token, input, searchBy, codemuni){
            $http.defaults.headers.common.Authorization = 'Bearer ' + token;
            return $http.get(
                'https://carto.goazimut.com/autocomplete?input=' + input + '&s='+ searchBy + '&codemuni=' + codemuni
            )
        }

        function getGoNetRoleInfo(token, matricule, codemuni){
            $http.defaults.headers.common.Authorization = 'Bearer '+ token;
            let data = {
                'matricule': matricule,
                'codemuni': codemuni
            }
            return $http.get('https://carto.goazimut.com/role/info?matricule=' + data.matricule + '&codemuni=' + data.codemuni)
        }

        function getCanadianMuniData(input){
            let  resource_id = "19385b4e-5503-4330-9e59-f998f5918363"
            return $http.get('https://www.donneesquebec.ca/recherche/api/3/action/datastore_search?resource_id=' + resource_id + '&q={ "munnom": "' + input + '" }')
        }

        function getGoNetMapServiceName(token){
            $http.defaults.headers.common.Authorization = 'Bearer '+ token;
            return $http.get("https://carto.goazimut.com/services/info")
        }

        function getGoNetMapService(token, matricule, cityMapName, layer_id){
            $http.defaults.headers.common.Authorization = 'Bearer '+ token;
            return $http.get("https://carto.goazimut.com/" + cityMapName +"/arcgis/" + layer_id  + "/query?returnGeometry=true&where=Matricule IN ('" + matricule +"')&outSR=4326&outFields=*&f=json")
        }

        return {
            getGoNetToken: getGoNetToken,
            getGoNetSearch: getGoNetSearch,
            getGoNetRoleInfo: getGoNetRoleInfo,
            getGoNetAutoComplete: getGoNetAutoComplete,
            getCanadianMuniData: getCanadianMuniData,
            getGoNetLayerId: getGoNetLayerId,
            getGoNetMapService: getGoNetMapService,
            getGoNetMapServiceName: getGoNetMapServiceName
        }
    }
})();
